import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import store from './store'
import MaterialModal from './MaterialModal'
import { Modal, Button } from 'hljd'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { visible }
      }
    } = this.props
    if (visible) {
      store.writeVisible = true
    } else {
      store.writeVisible = false
    }
  }

  componentDidMount() {
    store.getStatus()
  }
  render() {
    const header = ['小程序', '小程序注册']
    const { successVisible, closeTime } = store

    return (
      <HeaderView header={header} title="小程序注册">
        <div className={styles.wrap}>
          <div className={styles.banner}>
            <div className={styles.buttonBox}>
              <span className={styles.button} onClick={store.buy}>
                购买小程序注册
              </span>
            </div>
          </div>
          <div className={styles.contrast}>
            <p className={styles.title}>小程序注册解决方案</p>
            <p className={styles.infoTitle}>
              <span>传统注册</span>
              <span>婚礼纪平台注册</span>
            </p>
            <ul className={styles.clearfix}>
              <li>
                <img src="http://qnm.hunliji.com/o_1botm7rk984o6laa2o1p4a1eemr.png" />
                <p className={styles.p1}>注册流程繁琐</p>
                <p className={styles.p2}>
                  注册流程多达十余个，各种专业名词难以理解
                </p>
              </li>
              <li>
                <img src="http://qnm.hunliji.com/o_1botm7rk910rk17m41q6b13n18slu.png" />
                <p className={styles.p1}>注册流程简单</p>
                <p className={styles.p2}>
                  只需提供资料，注册流程由婚礼纪专业人员处理
                </p>
              </li>
              <li>
                <img src="http://qnm.hunliji.com/o_1botm7rk919brj1l17bc1nft7eis.png" />
                <p className={styles.p1}>容易出错</p>
                <p className={styles.p2}>
                  规则限制众多，一项填错，全部从头再来
                </p>
              </li>
              <li>
                <img src="http://qnm.hunliji.com/o_1botm7rk914dq1hgt1tbv1dlf1258v.png" />
                <p className={styles.p1}>0出错率</p>
                <p className={styles.p2}>
                  由专业人员提供婚礼行业定制模板，极大降低出错率
                </p>
              </li>
              <li>
                <img src="http://qnm.hunliji.com/o_1botm7rk949v14ru1t8a7mj173it.png" />
                <p className={styles.p1}>认证风险</p>
                <p className={styles.p2}>
                  认证极易失败，每次认证均需再次缴费，
                </p>
                <p className={styles.p2}>最终花费可达数千元</p>
              </li>
              <li>
                <img src="http://qnm.hunliji.com/o_1botm7rk91tedhqm1pi6shm114c10.png" />
                <p className={styles.p1}>认证成功率高达98%</p>
                <p className={styles.p2}>仅花费一次认证费用，</p>
                <p className={styles.p2}>
                  婚礼纪平台不收取任何手续费，省时省力
                </p>
              </li>
            </ul>
          </div>
        </div>
        <MaterialModal />

        <Modal
          visible={successVisible}
          footer={null}
          closable={false}
          width={415}
        >
          <div className={styles.modalbox}>
            <p>
              <img src="http://qnm.hunliji.com/o_1bmvoedr11ic6a1e1knl8pohda7.png" />
              <span>提交成功</span>
            </p>
            <p className={styles.tip}>
              请耐心等待工作人员联系，以及注意注册材料邮件的查收。
            </p>
            <div className={styles.button}>
              <Button type="primary" onClick={store.gotoAuthorize}>
                关闭({closeTime}s)
              </Button>
            </div>
          </div>
        </Modal>
      </HeaderView>
    )
  }
}
